<template>
    <div class="ccpay-adduser">
        <div class="ccpay-adduse-header">
                <span @click="back"> 返回</span>
                <span v-show="type=='1'">添加支付宝账户</span>
                <span v-show="type=='2'">添加银行卡账户</span>
                <span v-show="type=='3'">修改支付宝账户</span>
                <span v-show="type=='4'">修改银行卡账户</span>
                <span></span>
        </div>
        <div>
            <ul>
                <!-- <clicksss></clicksss> -->
                <li v-show="type=='1'||type=='3'">
                <p class="sup-tec" style="font-size: 16px;">收款二维码</p>
                    <div class="ccpay-add-img ">
                        <div class="imgactive" v-show="src!==''">
                             <img    style="width:100px;height:100px;object-fit: contain;" :src="src"/>
                             <span class="imgactiveafter" @click="removeimg">x</span>
                        </div>
                         <input
                            v-show="src==''"
                            multiple
                            type="file"
                            accept="image/*"
                            class="img-btn"
                            ref="ipt"
                            @change="updateImg"
                        />
                    </div>
                </li>
                <li>
                  <mt-field class="phoneNum phoneNumTull-lv"  
                   placeholder="姓名" 
                    v-model="name"
                    style="border-bottom: 1px solid #eee;" 
                    ></mt-field>
                </li>
                <li v-show="type=='1'||type=='3'">
                   <mt-field class="phoneNum phoneNumTull-lv"
                   
                      v-model="phoneNum"
                      placeholder="支付宝账号" 
                    ></mt-field>
                </li>
                <li v-show="type=='2'||type=='4'">
                   <mt-field class="phoneNum phoneNumTull-lv"
                      v-model="phoneNum"
                      placeholder="银行卡账号" 
                    ></mt-field>
                </li>
                <li v-show="type=='2'||type=='4'">
                   <mt-field class="phoneNum phoneNumTull-lv"
                      v-model="Bankname"
                      placeholder="开户行名称" 
                    ></mt-field>
                </li>
                <li v-show="type=='2'||type=='4'">
                   <mt-field class="phoneNum phoneNumTull-lv"
                      v-model="Bankaddress"
                      placeholder="开户行地址" 
                    ></mt-field>
                </li>
                <li v-show="type=='3'||type=='4'">
                    <mt-button class="mt-40" size="large" type="primary" 
                        @click="remove()">删除</mt-button>
                </li>
                <li>
                    <mt-button class="mt-40" size="large" type="primary" 
                        @click="adduser()">{{type=="1"||type=="2"?'添加':'修改'}}</mt-button>
                </li>
                <!-- <img :src="src"/> -->
                <!-- <li>1</li> -->
            </ul>
        </div>
    </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import clicksss from '../../component/ccpay/Dropzone.vue'
 import moment from  "moment"
export default {
    components:{
        clicksss
    },
    data(){
        return{
            type:'',//添加类型
            src:'',//img路径
            name:'',//姓名
            phoneNum:'',//账号
            Bankname:'',//银行
            Bankaddress:'',//银行地址
            fatherdata:'',
            id:'',
            file:'',
            awssrc:'',
        }
    },
    mounted(){
        this.type = this.$route.query.type
        if(this.$route.query.item){
             this.fatherdata = JSON.parse(this.$route.query.item)
             this.id = this.fatherdata.id
             if(this.type=="3"){
                 this.src = this.fatherdata.qr_link
                this.name = this.fatherdata.account_name
                this.phoneNum = this.fatherdata.user_id
             }else if(this.type=="4"){
                this.name = this.fatherdata.account_name
                this.phoneNum = this.fatherdata.platform_account_no
                this.Bankname = this.fatherdata.bank_name
                this.Bankaddress = this.fatherdata.bank_branch_name
             }
        }
        // console.log(JSON.parse(this.$route.query.item))
        
    },
    methods:{
        moment,
        back(){
            this.$router.go(-1)
        },
        randomString(len){
            //默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
            var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
            var tempLen = chars.length, tempStr='';
            for(var i=0; i<len; ++i){
                tempStr += chars.charAt(Math.floor(Math.random() * tempLen ));
            }
            return tempStr;
        },
        AWSupdateImg(type){
             Indicator.open();
             let file = this.file
             var nowtime = moment().valueOf()
             let filename = 'pay_account/ali/'+ nowtime  + this.randomString(20) +'.png' 
            //  console.log(file)
             let s3 = new AWS.S3({
                'accessKeyId' : 'AKIAREVQNU3CEQHLNE63',
                'secretAccessKey' : '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',
                Region: 'ap-northeast-1',
                // 'sessionToken' : 'ap-northeast-1'
              });
            let params = {
                Bucket: 'otcc-privacy-resource', /* required */
                Key:filename, /* required */
                Body: file,
                'Access-Control-Allow-Credentials': '*',
                'ACL': 'public-read',
            };
            s3.upload(params, (err, data) =>{
                 Indicator.close();
             if (err) {
                
                  this.$Toast('图片上传失败')
                //  console.log(err, err.stack) // an error occurred
            } else {
                 let src = s3.getSignedUrl('getObject', {Bucket: 'otcc-privacy-resource',Key:filename})
                 this.awssrc =   src.split('?')[0]
                // console.log(this.awssrc)
                 if(type=='addpay'){
                     this.twoaddpay()
                 }else{
                     this.twoemitpay(src.split('?')[0])
                 }
               
            }

           })
        },
        //上传头像
        updateImg(e){
            // console.log(e.target.files)
             let indexCount = 0;
           
             let kb =  e.target.files[0].size / 1024
                console.log( kb )
              if(kb>100){
                    this.$Toast('请上传小于100k的图片')
                    return
              }
                this.file = e.target.files[0]
             this.imgUpLoad(e.target.files, indexCount);
        },
        //删除头像
        removeimg(){
            this.src = ''
            this.file = ''
        },
        //获取路径
        imgUpLoad(allFile, indexCount){
            // this.checkImgLogo = true;
            // if (indexCount >= allFile.length) {
            //     this.$refs.ipt.value = "";
            //     this.checkImgLogo = false;
            //     return;
            // }
            
            let file = allFile[0];
            
            
            let reader = new FileReader();
            let config = {
                headers: {
                "Content-Type": "multipart/form-data"
                }
            };
            // console.log(file,'file')
            reader.readAsDataURL(file); //用文件加载器加载文件
            reader.onload = e => {
                // let img = new Image();
                // img.src = e.target.result;
                this.src = e.target.result;
                // console.log(e.target.result,'e.target.result')
            };
        },
        adduser(){
            if(this.type==1||this.type==2){
                if(this.type==1){
                    this.addpay()
                 }else{
                    this.addcard()
                }
           }else{
               if(this.type==3){
                    this.emitpay()
                 }else{
                    this.emitcard()
                }
           }
        },//添加支付宝
        twoaddpay(){
                
                this.$axios.post('/v1/traders/payaccount/alipay/create',{
                "user_id": this.phoneNum,
                "qr_link": this.awssrc,
                "account_name":  this.name
                }).then(res=>{
                    Indicator.close();
                    if(res.data){
                        this.$router.go(-1)
                        this.$Toast(res.msg)
                    }else{
                        this.$Toast(res.msg)
                    }
                })
        },
        addpay(){
            if(this.name==''){
                 this.$Toast('请输入姓名')
                 return
            }
            if(this.phoneNum==''){
                 this.$Toast('请输入支付宝账号')
                 return
            }
            if(this.src==''){
                 this.$Toast('请输入支付宝收款二维码')
                 return
            }
             this.AWSupdateImg('addpay')
           

        },//添加银行卡
        addcard(){
            if(this.name==''){
                this.$Toast('请输入姓名')
                 return
            }
            if(this.phoneNum==''){
                this.$Toast('请输入银行卡卡号')
                 return
            }
            if(this.phoneNum==''){
                this.$Toast('请输入银行卡卡号')
                 return
            }
            if(this.Bankname==''){
                this.$Toast('请输入开户行名称')
                 return
            }
            if(this.Bankaddress==''){
                this.$Toast('请输入开户行地址')
                 return
            }
            
                Indicator.open();
            this.$axios.post('/v1/traders/payaccount/bank/create',{
                   "platform_account_no": this.phoneNum,
                    "account_name": this.name,
                    "bank_name":this.Bankname,
                    "bank_branch_name": this.Bankaddress
                }).then(res=>{
                     Indicator.close();
                    if(res.data){
                        this.$router.go(-1)
                        this.$Toast(res.msg)
                    }else{
                        this.$Toast(res.msg)
                    }
                })
              
        },
        twoemitpay(src){
            
                
            this.$axios.post('/v1/traders/payaccount/alipay/update',{
                "user_id": this.phoneNum,
                "qr_link": src,
                "account_name": this.name,
                "id":this.id
            }).then(res=>{
                Indicator.close();
                if(res.code==0){
                     this.$router.go(-1)
                     this.$Toast('修改成功')
                }else{
                    this.$Toast(res.msg)
                }
            })
          
        },
        //修改支付宝
        emitpay(){
            if(this.file==''){
               if(this.name==''){
                    this.$Toast('请输入姓名')
                    return
                }
                if(this.phoneNum==''){
                    this.$Toast('请输入支付宝账号')
                    return
                }
                if(this.src==''){
                    this.$Toast('请输入支付宝收款二维码')
                    return
                }
               
                    this.$MessageBox.confirm('',{
                        title:'提示',
                        message:`您确定要执行该操作 `,
                        confirmButtonText:'确定',
                        cancelButtonText:'取消'
                    }).then(action => {
                          this.twoemitpay(this.src)
                      })
                
            }else{
                if(this.name==''){
                    this.$Toast('请输入姓名')
                    return
                }
                if(this.phoneNum==''){
                    this.$Toast('请输入支付宝账号')
                    return
                }
                     this.$MessageBox.confirm('',{
                        title:'提示',
                        message:`您确定要执行该操作 `,
                        confirmButtonText:'确定',
                        cancelButtonText:'取消'
                    }).then(action => {
                          this.AWSupdateImg('emitpay')
                    })
                
            }
            
        },
        //修改银行卡 
        emitcard(){
            if(this.name==''){
                this.$Toast('请输入姓名')
                 return
            }
            if(this.phoneNum==''){
                this.$Toast('请输入银行卡卡号')
                 return
            }
            if(this.phoneNum==''){
                this.$Toast('请输入银行卡卡号')
                 return
            }
            if(this.Bankname==''){
                this.$Toast('请输入开户行名称')
                 return
            }
            if(this.Bankaddress==''){
                this.$Toast('请输入开户行地址')
                 return
            }
             
            this.$MessageBox.confirm('',{
                title:'提示',
                message:`您确定要执行该操作 `,
                confirmButtonText:'确定',
                cancelButtonText:'取消'
            }).then(action => {
                 Indicator.open();
            this.$axios.post('/v1/traders/payaccount/bank/update',{
                "platform_account_no": this.phoneNum,
                "account_name": this.name,
                 "bank_name":this.Bankname,
                 "bank_branch_name": this.Bankaddress,
                 "id":this.id
            }).then(res=>{
                 Indicator.close();
                 if(res.code==0){
                     this.$router.go(-1)
                     this.$Toast('修改成功')
                }else{
                    this.$Toast(res.msg)
                }
            })
            }).catch(error =>{
                
            })

        },
        remove(){
             this.$MessageBox.confirm('',{
                title:'提示',
                message:`您确定要执行该操作 `,
                confirmButtonText:'确定',
                cancelButtonText:'取消'
            }).then(action => {
                this.removeuser()
               
            }).catch(error =>{
                
            })
        },
        removeuser(){
            Indicator.open();
            this.$axios.post('/v1/traders/payaccount/remove',{
                 "user_id": this.phoneNum,
                 "qr_link": this.src,
                 "account_name": "赵小帅",
                "id": this.id
            }).then(res=>{
                  Indicator.close();
                if(res.code==0){
                     this.$router.go(-1)
                     this.$Toast('删除成功')
                }else{
                    this.$Toast(res.msg)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .ccpay-adduser{
          background: white;
          height: 100%;;
        .ccpay-adduse-header{
            background: white;
            display: flex;
            justify-content: space-between;
            padding: 1rem;
        }
    }
    .sup-tec{
             color: #888;
            text-align: center;
            line-height: 3rem;
        }
    .ccpay-add-img{
        background: white;
        // margin-top: 3rem;
        position: relative;
        // display: flex;
        width: 100%;
        height: 100px;;
        .imgactive{
            position: absolute;
            width: 100px;
            height: 100px;
            left: 50%;;
            margin-left: -50px;
        }
        .imgactiveafter{
            position: absolute;
            right: -20px;
            top: 0;
            padding-left: 2px;
            padding-right: 2px;
            font-size: 1.2rem;
            color: #ccc;
        }
        input{
            position: absolute;
            width: 100px;
            height: 100px;
            left: 50%;;
            margin-left: -50px;
        }
        margin-bottom: 0.5rem;
    }
    .ccpay-add-img .img-btn {
        border: none !important;
        overflow: hidden;
    }
    .ccpay-add-img .img-btn::after {
        content: "";
        padding: 0 !important;
        background: url("../../../static/mobile_img/addimg.png") #fff;
        width: 100px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        // z-index: 99;
        background-size: cover;
    }
    .ccpay-resadd-img{
        margin-bottom: 1rem;
        display: flex;
        justify-content: center;
        button{
             background: #ccc;
            padding: 6px;
            outline: none;
            border: none;
            color: white;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Receivables/adddetail.vue